import { render } from "./scoreShow.vue?vue&type=template&id=02c9de4a&scoped=true"
import script from "./scoreShow.vue?vue&type=script&lang=js"
export * from "./scoreShow.vue?vue&type=script&lang=js"

import "./scoreShow.vue?vue&type=style&index=0&id=02c9de4a&scoped=true&lang=less"

import exportComponent from "/dev/shm/repo/piano-dp8c0m8ga1zm/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-02c9de4a"]])

export default __exports__